import { initProductForm } from "@theme/cart";
import EmblaCarousel from "embla-carousel";
import { updateDomComponent } from "@theme/critical";

class VariantPicker extends HTMLElement {
  constructor() {
    super();
    this.submitButton = this.closest(".product-details").querySelector(`[type="submit"]`);
  }

  connectedCallback() {

    const options = this.querySelectorAll(
      'input[type="radio"][name^="option["]',
    );

    if (!options.length) {
      return;
    }

    const getChecked = () => {
      const checked = Array.from(options).filter((o) => o.checked);
      return checked.map((o) => o.value).join(",");
    };

    /**
     * Aggiorna lo stato del pulsante di submit in base al variant selezionato
     * @param {HTMLInputElement} variant
     */
    const updateSubmitButton = (variant) => {
      if (!this.submitButton) {
        return;
      }

      const variantId = variant.dataset.variantId;
      const availableText = this.submitButton.dataset.availableText || "Add to bag";
      const unavailableText = this.submitButton.dataset.unavailableText || "Notify me";
      const selectText = this.submitButton.dataset.selectText || "Select variant";

      const updateText = (text) => {
        const textSpan = this.submitButton.querySelector(".btn-text");
        if (textSpan) {
          textSpan.textContent = text;
        } else {
          this.submitButton.value = text;
        }
      };

      document.querySelector("input[name='id']").value = variantId;

      if (!variant) {
        this.submitButton.disabled = true;
        this.submitButton.setAttribute("aria-disabled", "true");
        updateText(selectText);
        return;
      }

      this.submitButton.disabled = false;
      this.submitButton.setAttribute("aria-disabled", "false");

      if (variant.classList.contains("disabled")) {
        this.submitButton.classList.add("notify_me");
        updateText(unavailableText);
      } else {
        this.submitButton.classList.remove("notify_me");
        updateText(availableText);
      }
    };

    /**
     * Aggiorna l'URL e i contenuti in pagina prodotto con il variant selezionato
     * @param {HTMLInputElement} variant
     */
    const updatePage = async (variant) => {
      if (!variant) return;

      const variantId = variant.dataset.variantId;
      const url = new URL(window.location.href);

      // Se siamo nella pagina prodotto ufficiale, aggiorniamo URL e prezzi
      if (
        document.body.classList.contains("template-product") &&
        this.closest(".product-wrapper")
      ) {

        url.searchParams.set("variant", variantId);
        window.history.pushState({ variantId: variantId }, "", url.toString());

        await updateDomComponent(
          [".product-wrapper .product-price"],
          ["product"],
          `${url.toString()}${url.search ? "&" : "?"}variant=${variantId}`,
          { mode: "outerHtml", returnDocument: false },
        );
      }

      // Lanciamo l'evento con bubbles: true per permettere ai genitori (come QuickBuy) di intercettarlo
      this.dispatchEvent(
        new CustomEvent("variant-change", {
          bubbles: true,
          composed: true,
          detail: { variantId },
        }),
      );
    };

    options.forEach((o) => {
      o.addEventListener(
        "change",
        () => {
          updateSubmitButton(o)
          updatePage(o);
        }
      );
    });
  }

  disconnectedCallback() {
  }
}

if (!customElements.get("variant-picker")) {
  customElements.define("variant-picker", VariantPicker);
}


class ColorsContainer extends HTMLElement {
  constructor() {
    super();
    this.labels = this.querySelectorAll("ul span");
    this.bullets = this.querySelectorAll("ul a");
  }

  connectedCallback() {
    this.bullets.forEach((bullet) => {

      bullet.addEventListener("mouseenter", (ev) => {
        this.labels.forEach(label => { label.classList.add('hide') })

        const over = ev.currentTarget;

        over.previousElementSibling.classList.remove('hide');
        over.previousElementSibling.classList.add("show");
      });

      bullet.addEventListener("mouseleave", (ev) => {
        this.labels.forEach(label => {
          label.classList.remove('hide');
          label.classList.remove("show");
        })
      });

    })
  }

  disconnectedCallback() {
  }
}

if (!customElements.get("alternative-colors-container")) {
  customElements.define("alternative-colors-container", ColorsContainer);
}


function initFancybox() {

  if (typeof Fancybox !== "undefined") {
    console.log("Fancybox è pronto, inizializzazione...");
    Fancybox.bind("[data-fancybox]", {
      theme: "light",

      animated: true,
      showClass: "fancybox-zoomIn",
      hideClass: "fancybox-fadeOut",

      dragToClose: false,

      Images: {
        fit: "cover",
        zoom: true
      },

      Carousel: {
        transition: "slide",
        Zoomable: {
          Panzoom: {
            startPos: {
              scale: "cover",
            },
            panMode: "mousemove",
            mouseMoveFactor: 1,
            minScale: "cover",
            maxScale: "max",
          },
        },
        Thumbs: {
          type: "classic",
        },
        Toolbar: {
          display: {
            left: ["counter"],
            middle: [
            ],
            right: ["close"],
          },
        }
      }
    });

  } else {
    console.warn("Fancybox non è ancora definito");
  }
}


function initPrefetchColorVariants() {
  const colorLinks = document.querySelectorAll(".js-color-variant-link");

  const prefetchUrl = (url) => {
    if (!document.querySelector(`link[rel="prefetch"][href="${url}"]`)) {
      const linkEl = document.createElement("link");
      linkEl.rel = "prefetch";
      linkEl.href = url;
      linkEl.as = "document";
      document.head.appendChild(linkEl);
    }
  };

  colorLinks.forEach((link) => {
    const url = link.dataset.prefetchUrl;
    if (!url) return;

    link.addEventListener("mouseenter", () => prefetchUrl(url), { once: true });

    link.addEventListener("touchstart", () => prefetchUrl(url), {
      passive: true,
      once: true,
    });
  });
}

function initPdp() {

  initFancybox();
  createEmbla();
  initPrefetchColorVariants();

  document.querySelectorAll("form[data-type='add-to-cart-form']").forEach((form) => {
    initProductForm(form);
  });
}


function initPdpActions() {
  const openShareBtn = document.getElementById("open-share");
  const closeShareBtn = document.getElementById("close-share");
  const shareModal = document.getElementById("sharerModal");
  const overlay = document.querySelector(".sharer_overlay");


  const openSizeGuideBtn = document.getElementById("size-guide-link");
  const closeSizeGuideBtn = document.getElementById("close-size-guide");
  const sizeGuideModal = document.getElementById("size-guide-modal");


  if (openShareBtn && closeShareBtn && shareModal) {
    openShareBtn.addEventListener("click", (e) => {
      e.preventDefault();
      shareModal.setAttribute("aria-hidden", "false")
      shareModal.classList.add("open");
    });

    closeShareBtn.addEventListener("click", (e) => {
      e.preventDefault();
      shareModal.setAttribute("aria-hidden", "true")
      shareModal.classList.remove("open");
    });

    if (overlay) {
      overlay.addEventListener("click", (e) => {
        e.preventDefault();
        if (shareModel) {
          shareModal.setAttribute("aria-hidden", "true")
          shareModal.classList.remove("open");
        }
      });
    }
  }

  if (openSizeGuideBtn && closeSizeGuideBtn && sizeGuideModal) {
    openSizeGuideBtn.addEventListener("click", (e) => {
      e.preventDefault();
      sizeGuideModal.setAttribute("aria-hidden", "false")
      sizeGuideModal.classList.add("open");
    });

    closeSizeGuideBtn.addEventListener("click", (e) => {
      e.preventDefault();
      sizeGuideModal.setAttribute("aria-hidden", "true")
      sizeGuideModal.classList.remove("open");
    });
  }


}

function createEmbla() {
  const gallery = document.getElementById("pdp-gallery");
  if (!gallery) return;

  const viewportNode = gallery.querySelector(".embla__viewport");
  const dotsNode = gallery.querySelector(".embla__dots");
  const totalSlide = gallery.querySelectorAll(".embla__slide").length;

  if (!viewportNode || !dotsNode || totalSlide <= 1) return;

  const emblaApi = EmblaCarousel(viewportNode, {
    loop: true,
    align: "start",
    breakpoints: {
      "(min-width: 768px)": {
        active: false
      }
    }
  });
  addDotButtonAndClickHandlers(emblaApi, dotsNode);
}

function addDotButtonAndClickHandlers(emblaApi, dotsNode) {
  let dotNodes = [];
  let index = 0;

  const addDotBtnsWithClickHandlers = () => {
    dotsNode.innerHTML = emblaApi
      .scrollSnapList()
      .map(() => `<button class="embla__dot" type="button" aria-label="Show Image ${index++}"></button>`)
      .join("");

    const scrollTo = (index) => {
      emblaApi.scrollTo(index);
    };

    dotNodes = Array.from(dotsNode.querySelectorAll(".embla__dot"));
    dotNodes.forEach((dotNode, index) => {
      dotNode.addEventListener("click", () => scrollTo(index), false);
    });
  };

  const toggleDotButtonsActive = () => {
    const previous = emblaApi.previousScrollSnap();
    const selected = emblaApi.selectedScrollSnap();

    if (dotNodes[previous]) {
      dotNodes[previous].classList.remove("embla__dot--selected");
    }

    if (dotNodes[selected]) {
      dotNodes[selected].classList.add("embla__dot--selected");
    }
  };

  addDotBtnsWithClickHandlers();
  toggleDotButtonsActive();

  emblaApi
    .on("reInit", addDotBtnsWithClickHandlers)
    .on("reInit", toggleDotButtonsActive)
    .on("select", toggleDotButtonsActive);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPdp, { once: true });
  document.addEventListener("DOMContentLoaded", initPdpActions, { once: true });

} else {
  setTimeout(() => {
    initPdp();
    initPdpActions();
  }, 0);
}
